import React, { Component } from 'react';
import styled, { css, withTheme } from 'styled-components';
import PageHeader from '../components/PageHeader';
import PageHeaderMenu from '../components/PageHeaderMenu';
import ThemeViewer from '../components/ThemeViewer';
import __ from '../utils/translator';
import CollectionSubMenuThemes from '../components/CollectionSubMenuThemes';
import { withRouter } from 'react-router-dom';
import CollectionStore from '../flux/CollectionStore';
import CollectionStoreActions from '../flux/CollectionStoreActions';
import { Route } from "react-router-dom";
import CollectionSubMenu from '../components/CollectionSubMenu';
import CollectionSubMenuManuals from '../components/CollectionSubMenuManuals';
import PageLoadingOverlayStore from '../flux/PageLoadingOverlayStore';
import CollectionFirstTheme from '../components/CollectionFirstTheme';
import { Transition } from 'react-transition-group'
import { ENTERED, ENTERING, EXITED, EXITING } from 'react-transition-group/Transition';
import getSearchQueryFromQueryString
  from '../utils/getSearchQueryFromQueryString';
import PageTitle from '../components/PageTitle';
import PageHeaderMenuItem from '../components/PageHeaderMenuItem';
import RenderOnTablet from '../components/responsive/RenderOnTablet';
import RenderOnMobile from '../components/responsive/RenderOnMobile';
import PatternCardList from '../components/PatternCardList';
import CardsLayoutPattern from '../utils/CardsLayoutPattern';
import HomeThemeCard from '../components/HomeThemeCard';
import Header from '../components/organisms/Header';
import themeResponsiveProperty
  from '../components/responsive/themeResponsiveProperty';
import GlossaryStoreActions from "../flux/GlossaryStoreActions";

const defaultCollectionProps = {
  collectionId: null,
  collectionName: '-',
  collectionCover: null,
  themes: [],
  firstTheme: null,
  chapters: [],
  contents: [],
  glossary: [],
  manuals: [],
};

function mapCollectionProps(collection) {
  if (collection === null) {
    return defaultCollectionProps;
  }

  return {
    collectionId: collection.id,
    collectionName: collection.name,
    collectionCover: collection.cover,
    themes: collection.themes,
    firstTheme: collection.themes.length > 0 ? collection.themes[0] : null,
    chapters: collection.chapters,
    contents: collection.contents,
    glossary: collection.glossary,
    manuals: collection.manuals
  }
}

class Collection extends Component {
  state = {
    collectionDidLoad: false,
    ...defaultCollectionProps,
    isPageLoading: true,
    isCollectionURLExact: this.props.match.isExact,
  };

  subscriptions = [];

  componentDidMount() {
    CollectionStoreActions.find(this.props.match.params.collectionId);

    this.subscriptions.push(PageLoadingOverlayStore.addListener(() => {
      this.setState({ isPageLoading: PageLoadingOverlayStore.getState() });
    }));

    this.subscriptions.push(CollectionStore.addListener(() => {
      const collection = CollectionStore.getState();

      this.setState({
        collectionDidLoad: collection !== null,
        ...mapCollectionProps(collection),
      });
    }));
  }

  componentDidUpdate(prevProps) {
    if (prevProps.match.params.collectionId !== this.props.match.params.collectionId) {
      CollectionStoreActions.find(this.props.match.params.collectionId);
    }

    if (prevProps.match.isExact !== this.props.match.isExact) {
      this.setState({ isCollectionURLExact: this.props.match.isExact });
    }
  }

  componentWillUnmount() {
    this.subscriptions.forEach(subscription => subscription.remove());
  }

  render() {
    return (
      <div>
        <Header actions={themeResponsiveProperty(['back', 'search', 'glossary'], undefined)(this.props)} />

        <PageHeader
          smallTitle
          cover={this.state.collectionCover}
          crumbs={[__('Home'), __('Seasonal'), this.state.collectionName]}
          backUrl="/seasonal"
          title={this.state.collectionName}>

          <PageHeader.MenuContainer>
            <PageHeaderMenu>
              <PageHeaderMenuItem style={{ marginLeft: 0, }} to={`/seasonal/${this.state.collectionId}`}>
                {__('Introduction')}
              </PageHeaderMenuItem>
              <PageHeaderMenuItem to={`/seasonal/${this.state.collectionId}/themes`}>
                {__('Themes')}
              </PageHeaderMenuItem>
              <PageHeaderMenuItem style={{ marginRight: 0, }} to={`/seasonal/${this.state.collectionId}/manuals`}>
                {__('Manuals')}
              </PageHeaderMenuItem>
            </PageHeaderMenu>
          </PageHeader.MenuContainer>
        </PageHeader>

        <RenderOnTablet>
          <PageHeaderSubMenu isPageLoading={this.state.isPageLoading}>
            <Route path="/seasonal/:collectionId" exact render={() => (
              this.state.collectionDidLoad && (
                <PageTitle withTracking title={`Seasonal / ${this.state.collectionName}`} />
              )
            )} />

            <Route path="/seasonal/:collectionId/themes" exact render={() => {
              return (
                <React.Fragment>
                  {this.state.collectionDidLoad && (
                    <PageTitle withTracking title={`Seasonal / ${this.state.collectionName} / Themes`} />
                  )}
                  <CollectionSubMenu redirectTo={`/seasonal/${this.state.collectionId}`}>
                    <CollectionSubMenuThemes themes={this.state.themes} />
                  </CollectionSubMenu>
                </React.Fragment>
              );
            }} />

            <Route path="/seasonal/:collectionId/manuals" exact render={() => {
              return (
                <React.Fragment>
                  {this.state.collectionDidLoad && (
                    <PageTitle withTracking title={`Seasonal / ${this.state.collectionName} / Merchandising manuals`} />
                  )}
                  <CollectionSubMenu redirectTo={`/seasonal/${this.state.collectionId}`}>
                    <CollectionSubMenuManuals manuals={this.state.manuals} />
                  </CollectionSubMenu>
                </React.Fragment>
              );
            }} />
          </PageHeaderSubMenu>
        </RenderOnTablet>

        <PageContentContainer>
          <RenderOnTablet>
            <Transition in={ ! this.state.isCollectionURLExact} timeout={300} unmountOnExit>
              {state => <PageContentOverlay state={state} />}
            </Transition>
          </RenderOnTablet>

          <Route path="/seasonal/:collectionId" exact={this.props.theme.isMobile} render={() => (
            <React.Fragment>
              {this.state.collectionDidLoad && (
                <PageTitle withTracking title={`Seasonal / ${this.state.collectionName}`} />
              )}

              <ThemeViewer
                highlightWord={getSearchQueryFromQueryString(this.props.location.search)}
                chapters={this.state.chapters}
                contents={this.state.contents}
                glossary={this.state.glossary}
                onChapterEnter={(i) => {
                  CollectionStoreActions.chapterEnter(
                    this.state.chapters[i - 1]._id,
                    this.props.match.params.collectionId
                  );
                }}
                onGlossaryTermShow={(glossaryId) => {
                  GlossaryStoreActions.viewGlossaryTerm(glossaryId)
                }}
              />

              {this.state.firstTheme !== null && (
                <CollectionFirstTheme theme={this.state.firstTheme} />
              )}
            </React.Fragment>
          )} />

          <RenderOnMobile>
            <Route path="/seasonal/:collectionId/themes" exact render={() => {
              return (
                <div style={{
                  padding: '.25rem',
                }}>
                  {this.state.collectionDidLoad && (
                    <PageTitle withTracking title={`Seasonal / ${this.state.collectionName} / Themes`} />
                  )}

                  <PatternCardList pattern={CardsLayoutPattern.List}>
                    {this.state.themes.map(theme => (
                      <HomeThemeCard key={theme.id} theme={{
                        parentType: 'collections',
                        parentId: theme.collectionId,
                        themeId: theme.id,
                        themeCover: theme.cover,
                        parentName: theme.collectionName,
                        themeName: theme.name,
                        confidential: theme.confidential,
                        visibleOnlyForOutlets: theme.visibleOnlyForOutlets,
                        furSpecialist: false,
                      }} status={theme.status} fullWidth={true} />
                    ))}
                  </PatternCardList>
                </div>
              );
            }} />

            <Route path="/seasonal/:collectionId/manuals" exact render={() => {
              return (
                <React.Fragment>
                  {this.state.collectionDidLoad && (
                    <PageTitle withTracking title={`Seasonal / ${this.state.collectionName} / Merchandising manuals`} />
                  )}

                  <CollectionSubMenuManuals manuals={this.state.manuals} />
                </React.Fragment>
              );
            }} />
          </RenderOnMobile>
        </PageContentContainer>
      </div>
    );
  }
}

export default withTheme(withRouter(Collection));

const PageHeaderSubMenu = styled.div`
  z-index: 9;
  position: relative;

  ${({ isPageLoading }) => isPageLoading && css`
    display: none;
  `};
`;

const PageContentContainer = styled.div`
  z-index: 8; // PageHeaderSubMenu has zIndex: 9
  position: relative;
`;

const PageContentOverlay = styled.div`
  z-index: 99;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0,0,0,.8);
  opacity:  ${({ state }) => {
    switch (state) {
      case ENTERED:
      case ENTERING:
        return 1;

      case EXITING:
      case EXITED:
      default:
        return 0;
    }
  }};
  transition: opacity 300ms ease;
`;
